import { render, staticRenderFns } from "./ProductLinks.vue?vue&type=template&id=16679ebe&lang=html&"
import script from "./ProductLinks.vue?vue&type=script&lang=js&"
export * from "./ProductLinks.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductLinks.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "d3d5aa54"
  
)

export default component.exports